import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";


export const fetchStatisticsData = createAsyncThunk(
    'statistics/fetchData',
    async ({ perPage , year }) => {
        try {
            const response = await api.get('/statistics', {
                params: {
                    "perPage": perPage,
                    "year": year
                }
            });
            const data = response.data.data;
            return data;
        } catch (error) {
            return error;
        }

    }
)

export const statisticsSlice = createSlice({
    name: "statistics",
    initialState: {
        loading: false,
        error: null,
        statistics: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchStatisticsData.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchStatisticsData.fulfilled, (state, action) => {
                state.loading = false;
                state.statistics = action.payload;
            })
            .addCase(fetchStatisticsData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
    }
});
// export const { getSettingRequest, getSettingSuccess, getSettingFailure } = activitySlice.actions;
export default statisticsSlice.reducer;
